import React, { useState } from 'react';
import { Header } from './Components/Header';
import Drawer from './Components/Drawer';
import menu from './menu';
import { Outlet } from 'react-router-dom';
import { CssBaseline, styled } from '@mui/material';

interface LayoutProps {
  children: React.ReactNode;
}

// Create a styled main container
const MainContainer = styled('main')({
  padding: '18px 44px 18px 44px',
  minHeight: '100vh',
});

const MainLayout: React.FC<LayoutProps> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    debugger;
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      {/* Backdrop */}
      {/* <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          zIndex: drawerOpen ? 1200 : -1, // Assuming 1200 is higher than other elements on your page
          transition: 'opacity 0.3s',
          opacity: drawerOpen ? 1 : 0,
          pointerEvents: drawerOpen ? 'auto' : 'none',
        }}
        onClick={toggleDrawer} // Close the drawer when clicking the backdrop
      />*/}
      <Header toggleDrawer={toggleDrawer} />
      <Drawer open={drawerOpen} setDrawerOpen={setDrawerOpen} menuItems={menu} />
      <MainContainer
        style={{
          marginTop: 60,
        }}
      >
        <Outlet />
        {children}
      </MainContainer>
    </>
  );
};

export default MainLayout;
